import formatDate from 'helpers/formatDate';
import { useTranslation } from 'react-i18next';
import Submission from 'types/Submission';
import {
  SubmissionSidebarShortcuts,
  SubmissionSidebarMetadata,
} from './components';
import SubmissionSidebarDataCapture from './components/SubmissionSidebarDataCapture';
import SubmissionSidebarRoutingEvents from './components/SubmissionSidebarRoutingEvents';
import clsx from 'clsx';

interface Props {
  submission?: Submission;
  isOpen: boolean;
}

export default function SubmissionSidebar(props: Props) {
  const { submission, isOpen } = props;
  const { t } = useTranslation();

  return (
    <div
      style={{ height: `calc(100vh - var(--submission-topbar-height))` }}
      className={clsx(
        'pointer-events-auto fixed top-(--submission-topbar-height) right-0 flex w-(--submission-sidebar-width) flex-col border-l bg-background p-2 text-foreground transition-transform',
        !isOpen && 'translate-x-full'
      )}
    >
      <div className="flex-1 overflow-y-auto no-scrollbar">
        {!!submission && (
          <>
            <div className="mb-2">
              <div className="text-14 text-muted-foreground">
                {t('ugcRequestShow.submissions.sidebar.submittedDate', {
                  date: formatDate(submission.createdAt, {
                    timeZone: false,
                  }),
                })}
              </div>
            </div>

            <SubmissionSidebarMetadata submission={submission} />
            <SubmissionSidebarDataCapture submission={submission} />
            <SubmissionSidebarRoutingEvents submission={submission} />
          </>
        )}
      </div>

      <SubmissionSidebarShortcuts />
    </div>
  );
}
